// extracted by mini-css-extract-plugin
export default {"root":"SelectedGroupsList_root__5E7AR","list-item":"SelectedGroupsList_list-item__18ehA"};